export default async (context, $event) => {
    context.counterText = $event.length
    await context.text_validate(context, $event)
    let id = document.getElementById('add-text-page__textarea')

    if(context.selectColorStatus) {
        if($event.length === 0) {
            return context.pickColorsMarginBottom = id.offsetHeight - 3
        }
        context.pickColorsMarginBottom = id.offsetHeight + 7
    }
}